import { gql } from '@apollo/client';
import { leasingServiceTypeFragment, leasingServiceTypeLinkingFragment } from './fragments';

export const LEASING_SERVICE_TYPES = gql`
  query leasingServiceTypes($pager: PagerInputNew, $filters: LeasingServiceTypeFilters) {
    leasingServiceTypes(pager: $pager, filters: $filters) {
      total
      values {
        id
        code
        name
        categoryId
        categoryName
      }
    }
  }
`;

export const LEASING_SERVICE_TYPE = gql`
  query leasingServiceType($id: Int!) {
    leasingServiceType(id: $id) {
      ...leasingServiceType
    }
  }
  ${leasingServiceTypeFragment}
`;

export const LEASING_SERVICE_CLASSES = gql`
  query leasingServiceClasses {
    leasingServiceClasses {
      id
      name
    }
  }
`;

export const LEASING_SERVICE_AMOUNT_TYPES = gql`
  query leasingServiceAmountTypes {
    leasingServiceAmountTypes {
      id
      name
    }
  }
`;

export const LEASING_SERVICE_CALC_TYPES = gql`
  query leasingServiceCalcTypes {
    leasingServiceCalcTypes {
      id
      name
    }
  }
`;

export const LEASING_SERVICE_CATEGORIES = gql`
  query leasingServiceCategories {
    leasingServiceCategories {
      id
      name
    }
  }
`;

export const LEASING_SERVICE_TYPE_LINKINGS = gql`
  query leasingServiceTypeLinkings {
    leasingServiceTypeLinkings {
      ...leasingServiceTypeLinking
    }
  }
  ${leasingServiceTypeLinkingFragment}
`;

export const LEASING_SERVICE_TYPES_SUMMARY = gql`
  query leasingServiceTypesSummary {
    leasingServiceTypesSummary {
      id
      name
    }
  }
`;

export const LEASING_SERVICE_LINKING_TYPES = gql`
  query leasingServiceLinkingTypes {
    leasingServiceLinkingTypes {
      id
      name
    }
  }
`;
